module.exports = "/_next/static/images/cableDesign-859b9fab225e06ae2e9d9f7f7673d4fd.webp";